/**
 * Reloads the current page. Extracted into its own module so tests can mock it
 * without having to monkey-patch `window.location` (which isn't configurable in
 * jsdom).
 */
export function refreshPage(): void {
  window.location.reload();
}
